//
// PaxityProgress
//
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { useMemo } from 'react';

const PaxityProgress = function PaxityProgress(props) {
  const {
    className,
    style,
    full = false,
    sizePx,
    withDiv = false,
    pendingPopup = false,
  } = props;

  const containerClassName = useMemo(
    () => classNames(
      'relative',
      {
        'w-full h-full': full,
        'w-12 h-12': (!(sizePx || full)),
      },
      (withDiv) ? null : className,
    ),
    [className, full, sizePx, withDiv],
  );

  const baseClassName = 'absolute inset-0 w-full h-full p-1';

  const containerStyle = useMemo(
    () => {
      let ret;
      if (sizePx || style) {
        ret = style || {};

        if (sizePx) {
          ret.height = `${sizePx}px`;
          ret.width = `${sizePx}px`;
        }
      }

      return ret;
    },
    [sizePx, style],
  );

  const spinnerContent = (
    <>
      <img
        src="/images/svg/color/loading1.svg"
        className={`${baseClassName} paxity-loading1`}
        alt="loading..."
      />
      <img
        src="/images/svg/color/loading2.svg"
        className={`${baseClassName} paxity-loading2`}
        alt=""
      />
      <img
        src="/images/svg/color/loading3.svg"
        className={`${baseClassName} paxity-loading3`}
        alt=""
      />
    </>
  );

  if (pendingPopup) {
    return (
      <div
        className="z-2000 backdrop-blur-sm fixed inset-0 flex flex-row items-center justify-center p-12 overflow-hidden bg-pxBgMuted/70"
        tabIndex={-1}
        id="popupBackground"
      >
        <div className={containerClassName} style={containerStyle}>
          {spinnerContent}
        </div>
      </div>
    );
  }

  if (withDiv) {
    const divClassname = classNames(
      'w-full h-full flex items-center justify-center bg-transparent',
      className,
    );

    return (
      <div className={divClassname}>
        <div className={containerClassName} style={containerStyle}>
          {spinnerContent}
        </div>
      </div>
    );
  }

  return (
    <div className={containerClassName} style={containerStyle}>
      {spinnerContent}
    </div>
  );
};

PaxityProgress.propTypes = {
  className: PropTypes.string,
  style: PropTypes.shape({}),
  full: PropTypes.bool,
  sizePx: PropTypes.number,
  withDiv: PropTypes.bool,
  pendingPopup: PropTypes.bool,
};

export default PaxityProgress;
